// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2e0Xz","label":"Completed_label__3nBGz"};